<script>
  import TrabalheConoscoService from '../../../../domain/trabalhe-conosco/services/trabalhe-conosco'
  import moment from 'moment'

  export default {
    nome: 'trabalhe-conosco-lista',
    data () {
      return {
        lista: [{id: 1, nome: 'Raphael Henrique Silva Oliva', vaga: 'Desenvolvedor FullStack'}],
        isLoading: false,
        isDeleting: false
      }
    },
    computed: {
    },
    filters: {
      dataFilter (value) {
        return moment(value).format('L')
      }
    },
    created () {
      this.getProjetoList()
    },
    methods: {
      getProjetoList () {
        this.isLoading = true
        TrabalheConoscoService.listar()
          .then(result => {
            console.log(result.data)
            this.lista = result.data
            this.isLoading = false
          })
          .catch(error => {
            this.isLoading = false
            console.log(error.response.data.errors)
          })
      },
      deleteProjeto (id, index) {
        if (confirm('Tem certeza que deseja excluir ?')) {
          this.isDeleting = true
          TrabalheConoscoService.deletar(id)
            .then(result => {
              console.log('excluiu')
              this.lista.splice(index, 1)
              this.isDeleting = false
            })
            .catch(error => {
              console.log('deu erro', error.response.data.errors)
              this.isDeleting = false
            })
        }
      }
    }
  }
</script>

<template>
  <div>
    <div class="app-content-body ">
      <div class="bg-light lter b-b wrapper-md">
        <h1 class="m-n font-thin h3">Projetos</h1>
      </div>
      <span class="info-msg" v-if="isDeleting">Excluindo...</span>
      <div class="wrapper-md">
        <div class="panel panel-default">
          <div>
            <div class="table-responsive">
              <div id="DataTables_Table_0_wrapper" class="dataTables_wrapper form-inline dt-bootstrap no-footer">
                <div class="row">
                  <div class="col-md-6 col-sm-6 col-xs-6">
                    <div class="dataTables_length" id="DataTables_Table_0_length">
                      <label>Mostrar
                        <select name="DataTables_Table_0_length" aria-controls="DataTables_Table_0" class="form-control input-sm">
                          <option value="10">10</option>
                          <option value="25">25</option>
                          <option value="50">50</option>
                          <option value="100">100</option>
                        </select> resultados
                      </label>
                    </div>
                  </div>
                  <div class="col-md-6 col-sm-6 col-xs-6">
                    <div id="DataTables_Table_0_filter" class="dataTables_filter">
                      <label style="float: right;">Pesquisar:
                        <input type="search" class="form-control input-sm" placeholder="" aria-controls="DataTables_Table_0">
                      </label>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-12">
                    <table ui-jq="dataTable" class="table table-striped b-t b-b dataTable no-footer" id="DataTables_Table_0" role="grid" aria-describedby="DataTables_Table_0_info">
                      <thead>
                      <tr role="row">
                        <th style="width: 100px;" class="sorting" tabindex="0" aria-controls="DataTables_Table_0" rowspan="1" colspan="1" aria-label="Browser: activate to sort column ascending">Id</th>
                        <th style="width: 120px;" class="sorting" tabindex="0" aria-controls="DataTables_Table_0" rowspan="1" colspan="1" aria-label="Browser: activate to sort column ascending">Nome</th>
                        <th style="width: 120px;" class="sorting" tabindex="0" aria-controls="DataTables_Table_0" rowspan="1" colspan="1" aria-label="Browser: activate to sort column ascending">Telefone</th>
                        <th style="width: 120px;" class="sorting" tabindex="0" aria-controls="DataTables_Table_0" rowspan="1" colspan="1" aria-label="Browser: activate to sort column ascending">Email</th>
                        <th style="width: 120px;" class="sorting" tabindex="0" aria-controls="DataTables_Table_0" rowspan="1" colspan="1" aria-label="CSS grade: activate to sort column ascending">Cargo</th>
                        <th style="width: 120px;" class="sorting" tabindex="0" aria-controls="DataTables_Table_0" rowspan="1" colspan="1" aria-label="CSS grade: activate to sort column ascending">Data Cadastro</th>
                        <th style="width: 120px;" class="sorting" tabindex="0" aria-controls="DataTables_Table_0" rowspan="1" colspan="1" aria-label="CSS grade: activate to sort column ascending">Ação</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-if="isLoading">
                        <td colspan="7"><div class="m-t m-b text-center"><i class="fa fa-spinner fa-spin"></i> </div></td>
                      </tr>
                      <tr v-else-if="lista.length < 1">
                        <td colspan="7"><div class="m-t m-b text-center">Não há itens cadastrados</div></td>
                      </tr>
                      <tr class="odd" v-for="(projeto, index) in lista" :key="projeto.id" v-else>
                        <td valign="top" class="dataTables_empty">{{ projeto.id }}</td>
                        <td valign="top" class="dataTables_empty">{{ projeto.nome }}</td>
                        <td valign="top" class="dataTables_empty">{{ projeto.telefone }}</td>
                        <td valign="top" class="dataTables_empty">{{ projeto.email }}</td>
                        <td valign="top" class="dataTables_empty">{{ projeto.cargoNome }}</td>
                        <td valign="top" class="dataTables_empty">{{ projeto.dataCadastro ? moment(projeto.dataCadastro).format('LTS') : '-' }}</td>
                        <td valign="top" class="dataTables_empty">
                          <div class="row m-b-xs m-r-xs">
                            <!--div class="col-md-4">
                              <a class="btn btn-default" ui-toggle-class="button">
                                <i class="fa icon-cloud-upload text"></i>
                                <i class="fa icon-cloud-upload text-active text-danger"></i>
                              </a>
                            </div-->
                            <div class="col-md-4">
                              <a class="btn btn-default" ui-toggle-class="button" @click="$router.push({ name: 'trabalhe.conosco.detalhes', query: { id: projeto.id } })">
                                <i class="fa fa-eye"></i>
                              </a>
                            </div>
                            <div class="col-md-4">
                              <a class="btn btn-default" ui-toggle-class="button" href="javascript:;" @click="deleteProjeto(projeto.id, index)">
                                <i class="glyphicon glyphicon-trash"></i>
                              </a>
                            </div>
                          </div>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-6">
                    <div class="dataTables_info" id="DataTables_Table_0_info" role="status" aria-live="polite">Mostrando de {{ lista.length > 0 ? '1' : '0' }} até {{ lista.length }} de {{ lista.length }} registros</div>
                  </div>
                  <div class="col-sm-6">
                    <div class="dataTables_paginate paging_simple_numbers" id="DataTables_Table_0_paginate">
                      <ul class="pagination" style="float: right;">
                        <li class="paginate_button previous disabled" aria-controls="DataTables_Table_0" tabindex="0" id="DataTables_Table_0_previous">
                          <a href="#">Anterior</a>
                        </li>
                        <li class="paginate_button next disabled" aria-controls="DataTables_Table_0" tabindex="0" id="DataTables_Table_0_next">
                          <a href="#">Próximo</a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
  .info-msg {
    background-color: khaki;
    padding: 5px 15px;
    display: block;
    text-align: center;
  }
  .status {
    text-transform: uppercase;
  }
</style>



// WEBPACK FOOTER //
// Lista.vue?ea6844ce